// src/pages/NotAuthorized.js

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotAuthorized = () => {
  const navigate = useNavigate();

  // This function sends the user back to the previous page they were on.
  const goBack = () => navigate(-1);

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80vh',
    textAlign: 'center',
    fontFamily: 'sans-serif',
  };

  const headingStyle = {
    fontSize: '2.5rem',
    color: '#333',
    marginBottom: '1rem',
  };

  const textStyle = {
    fontSize: '1.2rem',
    color: '#666',
    marginBottom: '2rem',
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '1rem',
  };

  const buttonStyle = {
    padding: '10px 20px',
    fontSize: '1rem',
    cursor: 'pointer',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#f0f0f0',
    textDecoration: 'none',
    color: 'black',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>🚫 Access Denied</h1>
      <p style={textStyle}>
        You do not have the necessary permissions to view this page.
      </p>
      <div style={buttonContainerStyle}>
        <button onClick={goBack} style={buttonStyle}>
          Go Back
        </button>

      </div>
    </div>
  );
};

export default NotAuthorized;